export const translations = {
  en: {
    translation: {
      hero: {
        title: 'ZOE INSTITUTE',
        motto: 'Empowering Minds. Bridging Worlds.',
        english: 'English & French',
        programming: 'Programming',
        global: 'Global Skills',
      },
      vision: {
        title: 'Our Vision',
        text: 'To empower a new generation of learners with language fluency, digital intelligence, and global confidence — equipping students from India and the Middle East to communicate, create, and lead in a connected world.',
      },
      mission: {
        title: 'Our Mission',
        subtitle:
          'Bridging cultures and opportunities through excellence in language and technology education',
        point1:
          'Providing world-class training in English, French, and Programming that inspires mastery and confidence.',
        point2:
          'Cultivating an environment of growth, curiosity, and innovation that prepares students for global relevance.',
        point3:
          'Equipping learners with practical, future-ready skills that open doors to education, career, and cross-cultural engagement.',
        point4:
          'Delivering education with excellence, empathy, and integrity — empowering every student to thrive and make impact.',
        commitment: 'We are committed to excellence, empathy, and integrity',
      },
      courses: {
        title: 'Our Courses',
        subtitle:
          'Comprehensive programs designed to prepare you for global success',
        bookMeeting: 'Book a Consultation',
        categories: {
          english: 'English Language',
          ielts: 'IELTS Preparation',
          french: 'French Language',
          arabic: 'Arabic Language',
          school: 'School Education',
          university: 'University Level',
          computer: 'Computer Courses',
          programming: 'Programming Languages',
        },
      },
      contact: {
        title: 'Get Started Today',
        subtitle: "Fill out the form below and we'll get back to you shortly",
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        course: 'Course of Interest',
        message: 'Message',
        submit: 'Submit Inquiry',
        selectCourse: 'Select a course',
      },
    },
  },
  ar: {
    translation: {
      hero: {
        title: 'معهد زوي',
        motto: 'تمكين العقول. ربط العوالم.',
        english: 'الإنجليزية والفرنسية',
        programming: 'البرمجة',
        global: 'المهارات العالمية',
      },
      vision: {
        title: 'رؤيتنا',
        text: 'تمكين جيل جديد من المتعلمين بطلاقة اللغة والذكاء الرقمي والثقة العالمية - تجهيز الطلاب من الهند والشرق الأوسط للتواصل والإبداع والقيادة في عالم متصل.',
      },
      mission: {
        title: 'مهمتنا',
        subtitle:
          'ربط الثقافات والفرص من خلال التميز في تعليم اللغة والتكنولوجيا',
        point1:
          'توفير تدريب عالمي المستوى في اللغة الإنجليزية والفرنسية والبرمجة يلهم الإتقان والثقة.',
        point2:
          'تنمية بيئة من النمو والفضول والابتكار التي تعد الطلاب للأهمية العالمية.',
        point3:
          'تزويد المتعلمين بمهارات عملية جاهزة للمستقبل تفتح الأبواب للتعليم والمهنة والمشاركة عبر الثقافات.',
        point4:
          'تقديم التعليم بالتميز والتعاطف والنزاهة - تمكين كل طالب من الازدهار وإحداث التأثير.',
        commitment: 'نحن ملتزمون بالتميز والتعاطف والنزاهة',
      },
      courses: {
        title: 'دوراتنا',
        subtitle: 'برامج شاملة مصممة لإعدادك للنجاح العالمي',
        bookMeeting: 'احجز استشارة',
        categories: {
          english: 'اللغة الإنجليزية',
          ielts: 'إعداد IELTS',
          french: 'اللغة الفرنسية',
          arabic: 'اللغة العربية',
          school: 'التعليم المدرسي',
          university: 'المستوى الجامعي',
          computer: 'دورات الكمبيوتر',
          programming: 'لغات البرمجة',
        },
      },
      contact: {
        title: 'ابدأ اليوم',
        subtitle: 'املأ النموذج أدناه وسنعاود الاتصال بك قريبًا',
        name: 'الاسم الكامل',
        email: 'عنوان البريد الإلكتروني',
        phone: 'رقم الهاتف',
        course: 'الدورة المهتم بها',
        message: 'رسالة',
        submit: 'إرسال الاستفسار',
        selectCourse: 'اختر دورة',
      },
    },
  },
}
